import { render } from "./PageGroupReportDiagramTile.vue?vue&type=template&id=4ebae6d6"
import script from "./PageGroupReportDiagramTile.vue?vue&type=script&lang=js"
export * from "./PageGroupReportDiagramTile.vue?vue&type=script&lang=js"

import "./PageGroupReportDiagramTile.vue?vue&type=style&index=0&id=4ebae6d6&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__